module.exports = __webpack_public_path__ + "static/media/car.7f56c31c.jpg";